import { render } from "./purchasesBillShow.vue?vue&type=template&id=1715d00b&scoped=true"
import script from "./purchasesBillShow.vue?vue&type=script&lang=js"
export * from "./purchasesBillShow.vue?vue&type=script&lang=js"

import "./purchasesBillShow.vue?vue&type=style&index=0&id=1715d00b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1715d00b"]])

export default __exports__